module.exports = __webpack_public_path__ + "static/media/coins_2.e4da321d.webp";